import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode } from '../theme/tokens';

/**
 * Light/Dark theme for the agent console (redesign). Persisted per-agent to
 * localStorage; mirrors the langStore pattern. The layout *direction* and
 * *accent* are fixed house style (see theme/tokens.ts) and intentionally NOT
 * stored here — only the mode is user-switchable via the topbar + Settings.
 */
export const DEFAULT_MODE: ThemeMode = 'light';

interface ThemeState {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: DEFAULT_MODE,
      setMode: (mode) => set({ mode }),
      toggle: () => set({ mode: get().mode === 'dark' ? 'light' : 'dark' }),
    }),
    { name: 'css-agent-theme' }
  )
);
